import { render, staticRenderFns } from "./MultiSelectUiComponent.vue?vue&type=template&id=5a8b7448&scoped=true&"
import script from "./MultiSelectUiComponent.vue?vue&type=script&lang=ts&"
export * from "./MultiSelectUiComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MultiSelectUiComponent.vue?vue&type=style&index=0&id=5a8b7448&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8b7448",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
